<template>
    <div class="qiqi-user">
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="姓名">
                        <el-input v-model="searchForm.name" placeholder="姓名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="用户名">
                        <el-input v-model="searchForm.username" placeholder="用户名" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号">
                        <el-input v-model="searchForm.mobile" placeholder="手机号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" clearable>
                            <el-option label="全部" value=""></el-option>
                            <el-option label="无效" :value="0"></el-option>
                            <el-option label="有效" :value="1"></el-option>
                            <el-option label="待激活" :value="2"></el-option>
                            <el-option label="被锁定" :value="3"></el-option>
                            <el-option label="错误次数过多锁定" :value="4"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition"></div>
                <el-table
                    size="mini"
                    stripe
                    :data="tableData"
                    v-loading="loading"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column
                        prop="username"
                        label="用户名"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        label="姓名"
                        width="120">
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="邮箱"
                        width="200">
                    </el-table-column>
                    <el-table-column
                        prop="mobile"
                        label="手机号"
                        width="130">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        label="类型"
                        width="100">
                        <template slot-scope="scope">
                            {{scope.row.type === 1 ? '企业' : '个人'}}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="status"
                        label="状态"
                        width="100">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="getStatusType(scope.row.status)">
                                {{getStatusText(scope.row.status)}}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间"
                        width="160">
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="right" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                size="mini" type="text"
                                @click="handleAuthorize(scope.row)">授权成本中心</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
        </main>

        <el-dialog title="授权成本中心" :visible.sync="authorizeDialogVisible" :close-on-click-modal="false" width="500px">
            <el-form label-width="100px" size="mini">
                <el-form-item label="用户">
                    <el-input v-model="currentUser.name" disabled></el-input>
                </el-form-item>
                <el-form-item label="成本中心">
                    <el-tree
                        ref="costCenterTree"
                        :data="costCenterTreeData"
                        show-checkbox
                        node-key="id"
                        :props="{ label: 'name' }"
                        :default-checked-keys="checkedCostCenterIds"
                        style="border: 1px solid #EBEEF5; padding: 10px;">
                    </el-tree>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="authorizeDialogVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="onAuthorizeSubmit" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
const HEIGHT_OFFSET = 118;

export default {
    data() {
        return {
            tableConfig: {
                height: 0,
            },
            searchForm: {
                name: "",
                username: "",
                mobile: "",
                status: ""
            },
            loading: false,
            tableData: [],
            authorizeDialogVisible: false,
            currentUser: {
                id: "",
                name: ""
            },
            costCenterTreeData: [],
            checkedCostCenterIds: []
        }
    },
    mounted() {
        this.onSearch();
        window.addEventListener("resize", this.setTableHeight);
        setTimeout(() => {
            this.setTableHeight();
        }, 500);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setTableHeight);
    },
    methods: {
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            if (tablePosition) {
                const {top} = tablePosition.getBoundingClientRect();
                this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
            }
        },
        getStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'success',
                2: 'warning',
                3: 'danger',
                4: 'danger'
            };
            return typeMap[status] || 'info';
        },
        getStatusText(status) {
            const textMap = {
                0: '无效',
                1: '有效',
                2: '待激活',
                3: '被锁定',
                4: '错误次数过多锁定'
            };
            return textMap[status] || '';
        },
        onSearch() {
            this.loading = true;
            this.$axios.get(`/admin/qiqi/costCenter/users`)
                .then(response => {
                    const resp = response.data;
                    if (resp.header.status == 0) {
                        let data = resp.data;
                        if (this.searchForm.name) {
                            data = data.filter(item => item.name && item.name.includes(this.searchForm.name));
                        }
                        if (this.searchForm.username) {
                            data = data.filter(item => item.username && item.username.includes(this.searchForm.username));
                        }
                        if (this.searchForm.mobile) {
                            data = data.filter(item => item.mobile && item.mobile.includes(this.searchForm.mobile));
                        }
                        if (this.searchForm.status !== "") {
                            data = data.filter(item => item.status === this.searchForm.status);
                        }
                        this.tableData = data;
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: resp.header.msg || '查询失败'
                        });
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: '查询失败'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        async handleAuthorize(row) {
            this.currentUser = {
                id: row.id,
                name: row.name
            };
            this.checkedCostCenterIds = [];
            
            try {
                await this.loadCostCenters();
                await this.loadUserCostCenters(row.id);
                this.authorizeDialogVisible = true;
            } catch (error) {
                this.$notify.error({
                    title: '错误',
                    message: '加载数据失败'
                });
            }
        },
        loadCostCenters() {
            return new Promise((resolve, reject) => {
                this.$axios.post("/admin/qiqi/costCenter/list", {})
                    .then(response => {
                        const resp = response.data;
                        if (resp.header.status == 0) {
                            this.costCenterTreeData = this.buildTree(resp.data);
                            resolve();
                        } else {
                            reject(resp.header.msg);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        loadUserCostCenters(userId) {
            return new Promise((resolve, reject) => {
                this.$axios.get(`/admin/qiqi/costCenter/user/${userId}`)
                    .then(response => {
                        const resp = response.data;
                        if (resp.header.status == 0) {
                            this.checkedCostCenterIds = resp.data.map(item => item.id);
                            resolve();
                        } else {
                            reject(resp.header.msg);
                        }
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        buildTree(data) {
            const level1 = data.filter(item => item.level === 1);
            const level2 = data.filter(item => item.level === 2);
            const level3 = data.filter(item => item.level === 3);

            level2.forEach(l2 => {
                l2.children = level3.filter(l3 => l3.level2Id === l2.id);
            });

            level1.forEach(l1 => {
                l1.children = level2.filter(l2 => l2.level1Id === l1.id);
            });

            return level1;
        },
        onAuthorizeSubmit() {
            const checkedKeys = this.$refs.costCenterTree.getCheckedKeys();
            const halfCheckedKeys = this.$refs.costCenterTree.getHalfCheckedKeys();
            const costCenterIds = [...checkedKeys, ...halfCheckedKeys];

            const params = {
                userId: this.currentUser.id,
                costCenterIds: costCenterIds
            };

            this.$axios.post("/admin/qiqi/costCenter/authorize", params)
                .then(response => {
                    const resp = response.data;
                    if (resp.header.status == 0) {
                        this.$notify({
                            title: '成功',
                            message: '授权成功',
                            type: 'success'
                        });
                        this.authorizeDialogVisible = false;
                    } else {
                        this.$notify.error({
                            title: '错误',
                            message: resp.header.msg || '授权失败'
                        });
                    }
                })
                .catch(error => {
                    this.$notify.error({
                        title: '错误',
                        message: '授权失败'
                    });
                });
        }
    }
}
</script>

<style scoped>
.qiqi-user {
    height: 100%;
}
.content {
    padding: 20px;
}
</style>
